var exports = {
  "w": "xae11d333--c443a0--loader",
  "x": "xae11d333--c443a0--skeleton-animation",
};

module.exports = exports;
